import { useAuthContext } from "@r-and-a-shared-ui/auth-client";
import Image, { ImageProps } from "../Image/Image";
import { Link, LinkProps } from "../Link/Link";
import styles from './ReferralCodePanel.module.scss';
import { isNullOrUndefined } from "@r-and-a-shared-ui/utils";
import { CSSProperties } from "react";

export interface ReferralCodePanelProps {
  title: string;
  titleColor?: string;
  titleFont?: string;
  text: string;
  textColor?: string;
  textFont?: string;
  cta?: LinkProps;
  ctaColor?: string;
  backgroundImage?: ImageProps;
  backgroundColor?: string;
}

export function ReferralCodePanel(props: ReferralCodePanelProps) {
  const {
    userState: { user, referralCode },
  } = useAuthContext();

  if (isNullOrUndefined(user)) {
    return null;
  }

  const { 
    title, 
    titleColor,
    titleFont,
    text, 
    textColor,
    textFont,
    cta, 
    ctaColor,
    backgroundImage,
    backgroundColor,
  } = props;

  const inlineStyleBackground: CSSProperties = {
    backgroundColor,
  };

  const inlineStyleTitle: CSSProperties = {
    color: titleColor,
    fontFamily: titleFont,
  }

  const inlineStyleText: CSSProperties = {
    color: textColor,
    fontFamily: textFont,
  }

  const inlineStyleCTA: CSSProperties = {
    backgroundColor: ctaColor,
  }

  return (
    <div className={styles.wrapper} style={inlineStyleBackground}>
      {backgroundImage && (
        <div className={styles.background}>
          <Image
            imageUrl={backgroundImage.imageUrl}
            width={50}
            height={50}
            alt={backgroundImage.alt || 'Referral Code Panel Background'}
            schemaOrgContent={backgroundImage.schemaOrgContent}
          />
        </div>
      )}
      <div className={styles.content}>
        <h2 
          className={styles.content__title}
          style={inlineStyleTitle}
        >
          {title}
        </h2>
        <p 
          className={styles.content__referralCode}
          style={inlineStyleText}
        >
          {referralCode}
        </p>
        <p
          className={styles.content__text}
          style={inlineStyleText}
        >
          {text}
        </p>
        {cta && (
          <div 
            className={styles.content__cta}
            style={inlineStyleCTA}
          >
            <Link
              {...cta}
              className={styles.content__cta__button}
            >
              {cta.title}
            </Link>
          </div>
        )}
      </div>
    </div>
  )
}

export default ReferralCodePanel;